<template>
    <div>
        <a-modal v-model="isVisible" 
                :title="title"
                centered 
                on-ok="handleOk"
                :closable="false"
			    width="50%"
			    :dialog-style="{ top: '10px' }"
        >

            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    Close
                </a-button>
            </template>

            <div>
                <a-row :gutter="24" type="flex" align="stretch" class="header-solid h-full mb-24 category-infinite-container" >
                    <a-col :span="24" :lg="24" >
                        <a-input-search placeholder="input pickup number or customer name" 
                                        @change="handleSearch"
                                        :loading="loading"
                                        v-model="query"
                        />
                    </a-col>
                </a-row>
                <br/>
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" :lg="24" class="mb-24">
                        <a-card :bordered="false" 
                                class="header-solid h-full mb-24 demo-infinite-container" 
                                :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }"
                                :span="18" :lg="18" 
                                v-infinite-scroll="handleInfiniteOnload"
                                :infinite-scroll-disabled="busy"
                        >
                            <a-table class="mt-20"
				                :columns="cols"
                                :data-source="dataSource"
				                :pagination="{pageSize: pageSize}" 
				                rowKey="index"
			                >
                            <template slot="pickupNumber" slot-scope="pickupNumber">#{{ pickupNumber }}</template>

                            <template slot="status" slot-scope="status">
                                <a-tag v-if="status == 'Confirmed'" color="green">
                                    Confirmed
                                </a-tag>
                                <a-tag v-if="status == 'Cancelled'" color="red">
                                    Cancelled
                                </a-tag>
                            </template>

                            <template slot="isPaid" slot-scope="isPaid">
                                <a-tag v-if="isPaid == false" color="red">
                                    Not Paid
                                </a-tag>
                                <a-tag v-if="isPaid == true" color="green">
                                    Paid
                                </a-tag>
                            </template>

                            <template slot="actions" slot-scope="record">
                                <a-button-group>
                                    <a-button shape="circle" icon="eye" size="small" @click="handleBtnView(record)"/>
                                    <a-popconfirm placement="topLeft" ok-text="Yes" cancel-text="No" @confirm="handleBtnPrint(record)">
        					            <template slot="title">
          						            <p>Do you want to print it?</p>
        					            </template>
                                        <a-button shape="circle" icon="printer" size="small" />    
      					            </a-popconfirm>
                                    
                                </a-button-group>
                            </template>
                               
                            </a-table>         
                        </a-card>
                    </a-col>
                </a-row>
            </div>
         
        </a-modal>
       
    </div>
</template>

<script>

    import InfiniteScroll from 'v-infinite-scroll'
    import Moment from 'moment'
    const cols = [
        {
			title : 'PickupNumber',
			dataIndex : 'pickupNumber',
		},
		{
			title : 'Customer',
			dataIndex: 'customerName'
		},
        {
			title : 'Phone',
			dataIndex: 'phoneNumber'
		},
        {
			title : 'STATUS',
			dataIndex : 'status',
			scopedSlots : { customRender: 'status'} 
		}, 
		{
			title : 'IS PAID',
			dataIndex : 'isPaid',
			scopedSlots : { customRender: 'isPaid'} 
		},
		{
			title : 'ACTIONS',
			scopedSlots : { customRender: 'actions'},
			fixed: 'right'
			
		}

    ];

    export default {
        directives: { InfiniteScroll },
        data () {
            return {
                loading : false,
                cols,
                isVisible : false,
                busy: false,
                pageSize : 5,
                dataSource : [],
                info : {
                    customerName : '',
                    phoneNumber : '',
                    pickupNumber : '',
                    createdDate : ''
                },
                title: '',
                query : ''
            }
        },
    
        methods : {

            show() {
                this.reset();
                this.isVisible = true;
                //console.log(order)
            },

            formatTime(orderedTime) {
				return Moment(orderedTime).hour() + ':' + Moment(orderedTime).minute();
			},

            handleBtnView(record) {
                this.reset();
                this.isVisible = false;
                this.$emit('viewOrderEvent', record);
            },

            handleBtnPrint(record) {
                this.$emit('printOrderEvent', record);
            },

            async handleSearch(e) {
                //console.log('handleSearch')
                this.loading = true;
                await this.sleep(1000);
                let result = this.$store.getters['orderManager/ordersByPickupNumberOrCustomerName'](this.query);
                this.dataSource = result;
                //console.log(result)
                this.loading = false;
            },

            async sleep(miliSeconds) {
                return new Promise(r => setTimeout(r, miliSeconds));
            },


            getOptions(opt) {
                let options = [];
                let description = '';
                let descriptions = [];
                try {
                    options = JSON.parse(opt);
                    options.forEach(o => {
                        for(let i = 0; i< o.options.length; i++) {
                            descriptions.push(o.options[i].description);
                        }
                    });

                    for(let i = 0; i < descriptions.length; i++) {
                        if (descriptions.length - (i +1) > 0) {
                            description += descriptions[i] + ' , ';
                        }
                        else {
                            description += descriptions[i];
                        }
                    }
                }
                catch (err) {
                    console.log('Error in product options: ' + err);
                }
                finally {
                    return description;
                }
            },

            handleOk ()  {
                this.isVisible = false;
            },
            handleCancel () {
                this.isVisible = false;
            },
            reset() {
                this.dataSource = [];
                this.query = '';
            },
            handleInfiniteOnload() {

            },
        }
}
</script>

<style lang="scss">
	.full-modal {
  		.ant-modal {
    		max-width: 70%;
            max-height : 500px;
    		top: 50;
    		padding-bottom: 100;
    		margin: 100;
  		}
  		.ant-modal-content {
    		display: flex;
    		flex-direction: column;
    		height: calc(100vh);
  		}
  		.ant-modal-body {
    		flex: 1;
  		}
	}
</style>